// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__cUc5E","selected":"styles_selected__lrylm"};